import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledCollectionEntitiesAssistant
  from 'components/organisms/Assistants/CollectionEntitiesAssistant/CollectionEntitiesAssistant.styles';

const CollectionEntitiesAssistant = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'CollectionEntitiesAssistant');

  return <StyledCollectionEntitiesAssistant ref={ref} {...innerProps}
                                            title="Collection assistant"
                                            selectionTitle="What would you like to do with your collection?">
    {innerProps.children}
  </StyledCollectionEntitiesAssistant>
});

CollectionEntitiesAssistant.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default CollectionEntitiesAssistant;
